import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";

export const useDeleteProductsMutation = () => {
  return useMutation({
    mutationFn: (payload: any) =>
      axiosInstance
        .delete("/products", { data: { products: payload } })
        .then((res) => res.data),

    onSuccess: (data) => {
      message.success("Deleted successfully");
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || "An error occurred";
      message.error(errorMessage);
    },
  });
};
